import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="py-3 border-top mt-5">
    <div className="text-center text-muted small">
      © {new Date().getFullYear()} KCC Parts Distribution. All rights reserved. ·{' '}
      <Link to="/about">About Us</Link> ·{' '}
      <Link to="/shipping/policy">Shipping & Delivery Policy</Link> ·{' '}
      <Link to="/returns/policy">Return & Refund Policy</Link>
    </div>
  </footer>
);

export default Footer;
